module.exports = __webpack_public_path__ + "media/images/global/wedding-intro-e826d38e9be0d937df31046edb45b6eb.jpg";